import React from "react";
import styles from "./About.module.css";

const About = () => {
  const stats = [
    { number: "6+", label: "Years Web3" },
    { number: "4+", label: "Years Dev" },
    { number: "10+", label: "Projects" },
  ];

  return (
    <section id="about" className={styles.about}>
      <div className={styles.container}>
        <span className={`${styles.label} mono`}>01 /</span>
        <h2 className={styles.title}>About Me</h2>

        <div className={styles.grid}>
          {/* <div className={styles.image}>Avatar Image</div> */}
          <img
            src="/avatar.jpg"
            alt="Lucas"
            className={styles.image}
            style={{ objectFit: "cover", borderRadius: "8px" }}
          />

          <div className={styles.content}>
            <p className={styles.text}>
              I'm <strong>Lucas</strong>. I build React and React Native
              interfaces. My whole thing is taking ideas that are too
              complicated and making them simple.
            </p>

            <p className={styles.text}>
              Web3, traditional products, doesn't matter. The mission's the
              same: craft interfaces that actually work.
            </p>
            <p className={styles.text}>
              Bad UX annoys me, so I build stuff that's actually worth using.
              Good code matters, but great experiences matter more.
            </p>
            <p className={styles.text}>
              Outside of building, I'm exploring everything. Web3, AI, design
              tools, new frameworks. Always learning, always curious about
              what's next in tech.
            </p>

            <div className={styles.stats}>
              {stats.map((stat, index) => (
                <div key={index} className={styles.stat}>
                  <div className={`${styles.number} mono`}>{stat.number}</div>
                  <div className={`${styles.statLabel} mono`}>{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
